"use client"

import { Badge, Box, Flex, Heading, Table, Text } from '@chakra-ui/react';

const products = [
  { name: "Korepetycje grupowe", price: "79 zł/h" },
  { name: "Korepetycje indywidualne - poziom podstawowy", price: "135 zł/h" },
  { name: "Korepetycje indywidualne - poziom rozszerzony", price: "145 zł/h" },
  { name: "Kurs ósmoklasisty - 1 przedmiot", price: "249 zł/m-c" },
  { name: "Kurs ósmoklasisty - 2 przedmioty", price: "399 zł/m-c", tag: "20% taniej" },
  { name: "Kurs ósmoklasisty - 3 przedmioty", price: "449 zł/m-c", tag: "40% taniej" },
  { name: "Kurs maturalny - 1 przedmiot", price: "389 zł/m-c" },
  { name: "Kurs maturalny - 2 przedmioty", price: "619 zł/m-c", tag: "8% taniej" },
  { name: "Kurs maturalny - 3 przedmioty", price: "699 zł/m-c", tag: "17% taniej" },
]

export default function HomePricing() {
  return (
    <Box id="cennik" maxW="7xl" mx="auto" px="4" py="6">
    <Heading as="h2" size="lg" color="brand.orange.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="wider" textAlign="center">
        Cennik
    </Heading>
      <Table.Root maxW="4xl" mx="auto">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader fontWeight="bold">Zajęcia</Table.ColumnHeader>
            <Table.ColumnHeader fontWeight="bold">Cena</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {products.map((product) => {
            const [amount, unit] = product.price.split(' ');

            return (
              <Table.Row key={product.name}>
                <Table.Cell>
                  <Flex align="center" gap="2" flexWrap="wrap">
                    <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>{product.name}</span>
                    {product.tag && (
                      <Badge colorPalette="orange" variant="subtle" rounded="full" px="2">
                        {product.tag}
                      </Badge>
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex align="center" gap="1" whiteSpace="nowrap">
                    <span style={{ fontWeight: 'bold' }}>{amount}</span>
                    <Text style={{ fontWeight: 'normal', whiteSpace: 'nowrap' }}>{unit}</Text>
                  </Flex>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Root>
    </Box>
  )
}
